/**
 * @file: This file holds one stepper control.
 *
 * Compose has three numbers the operator raises and lowers: the count of a
 * media, the number of posts of a social item, and the number of bumper plays
 * of a takeover. The three were the same markup three times.
 *
 * The control reports a step and holds no number of its own. The clamping is a
 * rule, and every rule of the session is in `ComposeState`, so the buttons only
 * say whether a step is possible.
 */

class ComposeStepperController {
  constructor () {
    'ngInject'
  }

  get atMin () {
    return this.min !== undefined && this.min !== null && this.value <= this.min
  }

  get atMax () {
    return this.max !== undefined && this.max !== null && this.value >= this.max
  }

  down () {
    if (!this.atMin && !this.disabled) {
      this.onStep({ $delta: -1 })
    }
  }

  up () {
    if (!this.atMax && !this.disabled) {
      this.onStep({ $delta: 1 })
    }
  }
}

export default {
  bindings: {
    value: '<',
    min: '<?',
    max: '<?',
    // The text beside the number. Left out, the number stands alone.
    label: '@?',
    // A reason the control is off, which is also the title of both buttons.
    disabled: '<?',
    disabledNote: '@?',
    onStep: '&'
  },
  controller: ComposeStepperController,
  template: require('./compose-stepper.tpl.html').default
}

export { ComposeStepperController }
